export const LOCATION_SELECTED = "LOCATION_SELECTED";

export const UPDATE_LOCATION_DATA = "UPDATE_LOCATION_DATA";

export const ADD_LOCATION_IDS = "ADD_LOCATION_IDS";

export const RESET_LOCATION="RESET_LOCATION";